<template>
  <div class="flex-start">
    <span class="font-size-14 color-complementary-400 width-30">
      {{ `${percent}%` }}
    </span>
    <div class="jobs-profile__progress-box">
      <span :class="`jobs-profile__progress width-percent-${percent}`"></span>
    </div>
    <span
      v-if="suffixText"
      class="font-size-12 color-complementary-300 margin-right-8"
    >
      {{ suffixText }}
    </span>
  </div>
</template>

<script>
import { toRefs } from "vue";
export default {
  props: {
    percent: {
      type: [Number, String],
      default: 0,
    },
    suffixText: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    // generate props data
    const { percent } = toRefs(props);

    // return data to be used in template
    return { percent };
  },
};
</script>
